export {
  type UserGraphemeMeaningCard,
  userGraphemeMeaningCardTable,
} from "#user-grapheme-meaning-card-table";
